import c from 'classnames';
import { useState } from 'react';

import type { CitationSource } from '@repo/types';
import { Icon, TextColor, TextLink, Typography } from '@repo/ui';

import { useAnalytics } from '../../../contexts/analytics/AnalyticsProvider';

import styles from './DataSourcesSection.module.css';

interface DataSourcesSectionProps {
  sources: CitationSource[];
}

export const DataSourcesSection = ({ sources }: DataSourcesSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { trackEvent } = useAnalytics();

  if (sources.length === 0) return null;

  return (
    <div className={styles.dataSourcesContainer}>
      <div
        className={styles.header}
        onClick={() => setIsExpanded(prev => !prev)}
        role='button'
        tabIndex={0}
        aria-expanded={isExpanded}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsExpanded(prev => !prev);
          }
        }}
      >
        <div className={styles.titleWrapper}>
          <span className={styles.titleIcon}>
            <Icon name='file04' size='s' />
          </span>
          <Typography
            variant='subHeadline'
            weight='medium'
            color={TextColor.DARK}
          >
            Data sources ({sources.length})
          </Typography>
        </div>
        <span
          className={c(styles.chevron, { [styles.chevronOpen]: isExpanded })}
        >
          <Icon name='chevronDown' size='s' />
        </span>
      </div>
      <div
        className={c(styles.collapsible, {
          [styles.collapsibleOpen]: isExpanded,
        })}
      >
        <ul className={styles.sourcesList}>
          {sources.map((source, index) => (
            <li key={source.url} className={styles.sourceItem}>
              <TextLink
                label={source.title}
                to={source.url}
                external
                size='body-s'
                color={TextColor.DARKPURPLE}
                onClick={() =>
                  trackEvent('TinyAI Citation Clicked', {
                    citation_index: index + 1,
                    citation_url: source.url,
                  })
                }
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
